export function getHeightOfHidden(element) {
    const el = element as HTMLElement;
    
    // Store original styles and classes for restoration
    const originalStyles: { element: HTMLElement, style: string | null, className: string }[] = [];
    
    // Find all ancestors that might affect layout (up to body or a reasonable container)
    const ancestorsToModify: HTMLElement[] = [];
    let currentElement = el;
    let ancestorIsVisuallyHidden = false;
    
    while (currentElement && currentElement !== document.body) {
        ancestorsToModify.push(currentElement);
        
        // Store original state
        originalStyles.push({
            element: currentElement,
            style: currentElement.getAttribute('style'),
            className: currentElement.className
        });
        
        currentElement = currentElement.parentElement;
        
        // Stop if we hit a container that likely provides proper layout context
        if (currentElement && (
            currentElement.classList.contains('nav') ||
            currentElement.classList.contains('container') ||
            currentElement.classList.contains('wrapper') ||
            currentElement.id === 'main'
        )) {
            break;
        }
    }
    
    // Temporarily modify styles for accurate measurement
    ancestorsToModify.forEach((ancestor, index) => {
        if (index === 0) {
            // The element itself - ensure it can expand naturally but preserve internal spacing
            ancestor.setAttribute('style', 'opacity: 0 !important; height: auto !important; position: static !important; width: auto !important; clip: auto !important; overflow: visible !important;');
        } else {
            // Parent elements - only override the visually-hidden constraints, preserve content spacing
            ancestor.setAttribute('style', 'position: static !important; width: auto !important; height: auto !important; clip: auto !important; overflow: visible !important;');
        }
        
        // Temporarily remove visually-hidden class if present
        if (ancestor.classList.contains('visually-hidden')) {
            ancestorIsVisuallyHidden = true;
            ancestor.classList.remove('visually-hidden');
        }
    });
    
    // Force a reflow to ensure styles are applied
    element.offsetHeight;
    
    // Get the actual height
    let elementHeight = element.offsetHeight;

    if (ancestorIsVisuallyHidden) {
        elementHeight = element.offsetHeight + 64;
    }

    // Restore all original styles and classes
    originalStyles.forEach(({ element, style, className }) => {
        if (style) {
            element.setAttribute('style', style);
        } else {
            element.removeAttribute('style');
        }
        element.className = className;
    });
    
    return elementHeight;
}